import React, { useEffect, useRef, useState } from 'react';
import BlogCard from './BlogCard';

const ArticleContainer = ({ articles, isNewArticle }) => {
  const containerRef = useRef(null);
  const [transitioning, setTransitioning] = useState(false);
  const articlesRef = useRef(articles);

  // Gestion des transitions sans changer la largeur
  useEffect(() => {
    if (articlesRef.current !== articles) {
      // Capturer l'état actuel
      const containerWidth = containerRef.current?.getBoundingClientRect().width || 0;
      
      // Figer temporairement les dimensions
      setTransitioning(true);
      
      // Appliquer une classe spéciale pendant la transition
      document.body.classList.add('transitioning');
      
      // Assurer une largeur fixe
      if (containerRef.current) {
        containerRef.current.style.width = `${containerWidth}px`;
      }
      
      // Masquer très brièvement le contenu pendant le changement
      setTimeout(() => {
        articlesRef.current = articles;
        
        // Retirer la classe après transition
        setTimeout(() => {
          document.body.classList.remove('transitioning');
          setTransitioning(false);
          
          // Restaurer les styles naturels
          if (containerRef.current) {
            containerRef.current.style.width = '';
          }
        }, 200);
      }, 50);
    }
  }, [articles]);

  return (
    <div 
      ref={containerRef}
      className={`blog-articles-container ${transitioning ? 'opacity-95' : 'opacity-100'}`}
      style={{ transition: 'opacity 0.1s ease' }}
    >
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
        {articles.map(article => (
          <div 
            key={article.id}
            className="transition-all duration-200 hover:-translate-y-1 mb-4"
          >
            <BlogCard article={article} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ArticleContainer;
